<template>
  <div class="pagination" data-test="pagination">
    <mc-pagination id="pagination" :totalpages="lastPage" :currentpage="currentPage" @pagechange="selectedPageEvent" />
    <div class="pagination__results">
      <p>
        {{ $t("pagination.showing") }} {{ startPageCount }} - {{ endPageCount }}
        <template v-if="totalCount !== 0">{{ $t("pagination.of") }} {{ totalCount }}</template>
      </p>
    </div>
  </div>
</template>

<script>
import { getExportImportPage } from "@/lib/utilities";

export default {
  name: "Pagination",
  props: {
    activeView: {
      default: "",
      type: String
    },
    lastPage: {
      type: Number,
      default: 1
    },
    totalCount: {
      required: true,
      type: Number
    },
    currentPage: {
      required: true,
      type: Number
    }
  },
  emits: ["update-data-source"],
  data() {
    return {
      startPageCount: 1,
      endPageCount: parseInt(this.$t("common.paginationSize")),
      selectedPage: 1,
      showNavButton: true,
      prevNavTitle: this.$t("pagination.previous"),
      nextNavTitle: this.$t("pagination.next")
    };
  },
  computed: {
    pageSize() {
      return parseInt(this.$t("common.paginationSize"));
    }
  },
  watch: {
    activeView() {
      this.startPageCount = 1;
      this.selectedPage = 1;
      this.endPageCount =
        this.totalCount <= this.startPageCount + this.pageSize - 1
          ? this.totalCount
          : this.startPageCount + this.pageSize - 1;
    }
  },
  mounted() {
    this.startPageCount = (this.currentPage - 1) * this.pageSize + 1;
    this.endPageCount =
      this.totalCount <= this.startPageCount + this.pageSize - 1
        ? this.totalCount
        : this.startPageCount + this.pageSize - 1;
  },

  methods: {
    selectedPageEvent($event) {
      this.selectedPage = $event.detail;
      scrollTo({ top: 0, behavior: "smooth" });
      this.$emit("update-data-source", this.selectedPage);
      this.startPageCount = (this.selectedPage - 1) * this.pageSize + 1;
      this.endPageCount =
        this.totalCount <= this.startPageCount + this.pageSize - 1
          ? this.totalCount
          : this.startPageCount + this.pageSize - 1;
      this.$sendGAEvent({
        event: "UXEvent",
        category: "UX_ShipmentMngt",
        action: `${getExportImportPage()} ${this.activeView} Pagination`,
        label: this.selectedPage
      });
      this.$sendGAEvent({
        event: "DQCS",
        category: "SO_Pagination",
        action: "Click",
        label: { data: "Pagination", view: getExportImportPage(), tab: this.activeView, pageNo: this.selectedPage }
      });
    }
  }
};
</script>
